// frontend/src/Transliterate.js

import React, { useEffect, useRef, useState } from "react";

const LanguageCode = {
  ENGLISH: "en",
  AMHARIC: "am",
  ARABIC: "ar",
  BENGALI: "bn",
  CHINESE: "zh",
  GREEK: "el",
  GUJARATI: "gu",
  HINDI: "hi",
  KANNADA: "kn",
  MALAYALAM: "ml",
  MARATHI: "mr",
  NEPALI: "ne",
  ORIYA: "or",
  PERSIAN: "fa",
  PUNJABI: "pa",
  RUSSIAN: "ru",
  SANSKRIT: "sa",
  SINHALESE: "si",
  SERBIAN: "sr",
  TAMIL: "ta",
  TELUGU: "te",
  TIGRINYA: "ti",
  URDU: "ur",
};

const rtlLanguages = [
  "Arabic",
  "Hebrew",
  "Aramaic",
  "Dhivehi",
  "Sorani",
  "Persian",
  "Urdu",
  "Sindhi",
  "Pashto",
  "Yiddish",
];

const Transliterate = ({ language_script, onTextChange, targetRef }) => {
  const [lanControl, setLanControl] = useState(null);

  useEffect(() => {
    const loadGoogleApi = () => {
      const script = document.createElement("script");
      script.src = "https://www.google.com/jsapi";
      script.async = true;
      script.onload = () => {
        if (window.google && window.google.load) {
          window.google.load("elements", "1", {
            packages: "transliteration",
            callback: initializeTransliteration,
          });
        }
      };
      document.body.appendChild(script);
    };

    if (!window.google || !window.google.elements) {
      loadGoogleApi();
    } else {
      initializeTransliteration();
    }
  }, []);

  const initializeTransliteration = () => {
    if (!targetRef?.current) return;

    const targetLanguageCode = language_script
      ? LanguageCode[language_script.toUpperCase()] || "hi"
      : "hi";

    const options = {
      sourceLanguage: LanguageCode.ENGLISH,
      destinationLanguage: targetLanguageCode === "en" ? ["hi"] : [targetLanguageCode],
      shortcutKey: "ctrl+g",
      transliterationEnabled: targetLanguageCode !== "en",
    };

    const control = new window.google.elements.transliteration.TransliterationControl(
      options
    );
    control.makeTransliteratable([targetRef.current]);

    setLanControl(control);
  };

  useEffect(() => {
    if (lanControl && targetRef?.current) {
      const targetLanguageCode = language_script
        ? LanguageCode[language_script.toUpperCase()]
        : "hi";

      if (targetLanguageCode && targetLanguageCode !== "en") {
        lanControl.setLanguagePair(LanguageCode.ENGLISH, targetLanguageCode);
        lanControl.enableTransliteration();
      } else {
        lanControl.disableTransliteration();
      }

      targetRef.current.dir = rtlLanguages.includes(language_script) ? "rtl" : "ltr";
    }
  }, [language_script, lanControl, targetRef]);

  return null;
};

export default Transliterate;